import React, { useEffect, useState } from "react";
import { ModalScreen } from "../../../components/ModalScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import { ValFormReg } from "../../../../Validators/ValForms";
import { RegularExpressions } from "../../../../Helpers/RegularExpression";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { AnalisisComentariosLine } from "../../AnalisisComentariosLine";
import { ModalComentariosTimelineJDF } from "./ModalComentariosTimelineJDF";


export const ModalComentariosJDF = ({
    setOpenSolicitud,
    titulo,
    estado,
    comentarios
}) => {
    // const [comentarios, setComentarios] = useState("");
    // const [condiciones, setCondiciones] = useState({});
    // const [estatus, setEstatus] = useState({});

    // const onChange = (prop, value, sbool, smensaje) => {
    //     setComentarios(value);
    // };

    // useEffect(() => {
    //     setLoader({ ...loader, mostrar: true });
    //     request
    //         .get(`ACAnalisisDecicion/Condiciones?folio=${folio}`)
    //         .then((result) => {
    //             setLoader({ ...loader, mostrar: false });
    //             setCondiciones(result);
    //         })
    //         .catch((error) => {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire(
    //                 "VALIDAR CONDICIONES DE LA OPERACION",
    //                 JSON.stringify(error),
    //                 "error"
    //             );
    //         });
    // }, []);

    // const onEnviarComentario = (valor) => {
    //     const rescomentarios = ValFormReg(
    //         "Comentarios",
    //         comentarios,
    //         RegularExpressions.TextSpecialCharacter,
    //         15,
    //         2000
    //     );
    //     if (rescomentarios.isValid === false) {
    //         Swal.fire(
    //             "VALIDAR CONDICIONES DE LA OPERACION",
    //             rescomentarios.mensaje,
    //             "error"
    //         );
    //         return;
    //     }
    //     setLoader({ ...loader, mostrar: true });
    //     const post = {
    //         folio,
    //         comentarios,
    //         estatus: valor,
    //         idproceso: idproceso,
    //     };
    //     request
    //         .post("AC_Validar_Condiciones_Operacion/EnviarComentario", post)
    //         .then((result) => {
    //             setLoader({ ...loader, mostrar: false });
    //             setEstatus(result.estado);
    //             setComentarios("");
    //             Swal.fire({
    //                 title: "VALIDACION DE CONDICIONES",
    //                 text: "Registro guardado con éxito",
    //                 icon: "success",
    //                 customClass: {
    //                     container: "mi-superpoop",
    //                 },
    //             });
    //             setOpenSolicitud(false);
    //         })
    //         .catch((error) => {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire(
    //                 "ANALISIS DE SOLICITUD DE CREDITO",
    //                 JSON.stringify(error),
    //                 "error"
    //             );
    //         });
    // };

    return (
        <ModalScreen close={setOpenSolicitud}>
            <span
                className="filtro-soy-span-close-comentarios-jdf"
                onClick={() => setOpenSolicitud(false)}
            >
                X
            </span>
            <PlantillaScreen
                titulo={titulo}
                className={"asc-modal-comentarios-jdf"}
            >
                <ModalComentariosTimelineJDF
                    tiempotranscurrido={estado.tiempotranscurrido}
                    tiempoestimado={estado.tiempoestimado}
                    comentarios={comentarios}
                />
            </PlantillaScreen>
        </ModalScreen>
    );
};
